<template>
  <div class="tab-panel-body">
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-youtube</v-icon>
        <span class="config-section-label">YouTube</span>
      </div>
    </div>

    <!-- Credentials section -->
    <div class="yt-section">
      <span class="yt-subsection-title">
        <v-icon x-small class="mr-1" color="text_secondary">mdi-key</v-icon>
        Credenciais
      </span>

      <template v-if="credenciais">
        <div class="yt-credentials">
          <div class="yt-credential-row">
            <label class="yt-label">Client ID</label>
            <v-text-field
              solo
              flat
              dense
              hide-details
              v-model="client_id"
              background-color="surface_tertiary"
              placeholder="Client ID"
            />
          </div>
          <div class="yt-credential-row">
            <label class="yt-label">Client Secret</label>
            <v-text-field
              solo
              flat
              dense
              hide-details
              v-model="client_secret"
              background-color="surface_tertiary"
              placeholder="Client Secret"
            />
          </div>
          <div class="yt-credential-actions">
            <v-btn
              small
              color="primary"
              @click.prevent="atualizarCredenciais"
              :loading="loadingSave"
              class="yt-btn"
            >
              <v-icon small class="mr-1">mdi-check</v-icon>
              Salvar
            </v-btn>
            <v-btn
              small
              outlined
              color="primary"
              @click.prevent="autenticarYoutube"
              class="yt-btn"
            >
              <v-icon small class="mr-1">mdi-login</v-icon>
              Autenticar
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="sc-empty-state">
          <v-icon size="32" color="text_secondary" class="mb-2">mdi-key-plus</v-icon>
          <span class="sc-empty-state__title">Nenhuma credencial cadastrada para esta produção</span>
          <ModalCadastrarCredenciaisYoutube />
        </div>
      </template>
    </div>

    <!-- Lives section -->
    <div class="yt-section">
      <div class="yt-subsection-header">
        <span class="yt-subsection-title">
          <v-icon x-small class="mr-1" color="text_secondary">mdi-broadcast</v-icon>
          Lives ativas
        </span>
        <v-btn
          small
          outlined
          color="primary"
          @click="fetchLives"
          :loading="loadingLives"
          class="yt-btn"
        >
          <v-icon small class="mr-1">mdi-refresh</v-icon>
          Buscar lives
        </v-btn>
      </div>

      <div v-if="youtube_lives && youtube_lives.length > 0" class="yt-lives-list">
        <div
          v-for="live in youtube_lives"
          :key="live.live_chat_id"
          class="yt-live-item"
          :class="{ 'yt-live-active': live.flg_ativo }"
        >
          <div class="yt-live-info">
            <v-icon small :color="live.flg_ativo ? 'primary' : 'text_secondary'" class="mr-2">
              {{ live.flg_ativo ? 'mdi-broadcast' : 'mdi-broadcast-off' }}
            </v-icon>
            <span class="yt-live-title">{{ live.dsc_titulo_live_chat }}</span>
          </div>
          <v-switch
            :input-value="live.flg_ativo"
            @change="changeFlgAtivo(live)"
            color="primary"
            hide-details
            dense
            class="mt-0 pt-0"
          />
        </div>
      </div>

      <div v-else-if="youtube_lives && youtube_lives.length === 0" class="sc-empty-state">
        <v-icon size="32" color="text_secondary" class="mb-2">mdi-broadcast-off</v-icon>
        <span class="sc-empty-state__title">Nenhuma live encontrada</span>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import ModalCadastrarCredenciaisYoutube from "./ModalCadastrarCredenciaisYoutube.vue";

export default {
  name: "ModalConfigChatYoutube",
  components: { ModalCadastrarCredenciaisYoutube },
  data() {
    return {
      client_id: null,
      client_secret: null,
      loadingSave: false,
      loadingLives: false,
    };
  },
  computed: {
    ...mapGetters({
      credenciais: "producoes/getterProducaoCredenciaisYoutube",
      youtube_lives: "youtube/getYoutubeLives",
    }),
  },
  watch: {
    credenciais(val) {
      if (val) {
        this.client_id = val.client_id;
        this.client_secret = val.client_secret;
      }
    },
  },
  created() {
    if (this.credenciais) {
      this.client_id = this.credenciais.client_id;
      this.client_secret = this.credenciais.client_secret;
    }
  },
  methods: {
    ...mapActions({
      getYoutubeLives: "youtube/getYoutubeLives",
      getProducaoCredenciaisYoutube: "producoes/getProducaoCredenciaisYoutube",
    }),
    async autenticarYoutube() {
      try {
        const response = await apiClient.get(
          `/youtube/generateOAuthURL?client_id=${this.credenciais.client_id}&client_secret=${this.credenciais.client_secret}`
        );
        window.open(response.data.url, "_blank").focus();
      } catch (error) {
        this.$toast.error("Erro ao gerar URL de autenticação.");
      }
    },
    async atualizarCredenciais() {
      if (!this.client_id || !this.client_secret) {
        this.$toast.warning("Insira os dados corretamente.");
        return;
      }
      this.loadingSave = true;
      try {
        await apiClient.patch(`youtube/update/${this.credenciais.cod_youtube_api}`, {
          client_id: this.client_id,
          client_secret: this.client_secret,
        });
        this.$toast.success("Credenciais atualizadas com sucesso.");
        await this.getProducaoCredenciaisYoutube(
          this.$store.state.producoes.selectedProducao.cod_producao
        );
      } catch (error) {
        this.$toast.error("Erro ao atualizar credenciais.");
      } finally {
        this.loadingSave = false;
      }
    },
    async fetchLives() {
      this.loadingLives = true;
      try {
        const codProducao = this.$store.state.producoes.selectedProducao?.cod_producao;
        await apiClient.get(`/youtube/active-lives-from-yt/${codProducao}`);
        await this.getYoutubeLives({ cod_producao: codProducao });
      } catch (error) {
        this.$toast.error("Erro ao buscar lives.");
      } finally {
        this.loadingLives = false;
      }
    },
    async changeFlgAtivo(item) {
      try {
        await apiClient.patch("/youtube/update-live-from-db", {
          live_chat_id: item.live_chat_id,
          flg_ativo: !item.flg_ativo,
        });
        this.$toast.success("Live atualizada com sucesso!");
        await this.getYoutubeLives({
          cod_producao: this.$store.state.producoes.selectedProducao?.cod_producao,
        });
      } catch (error) {
        this.$toast.error("Erro ao atualizar live.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Sections */
.yt-section {
  background: var(--sc-surface-tint-subtle);
  border-radius: var(--sc-radius-lg);
  padding: 16px;
  border: 1px solid var(--sc-border-subtle);
  margin-bottom: 16px;
}

.yt-subsection-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.yt-subsection-title {
  display: flex;
  align-items: center;
  font-size: var(--sc-text-base);
  font-weight: 600;
  color: var(--v-text_primary-base);
  margin-bottom: 12px;
}

.yt-subsection-header .yt-subsection-title {
  margin-bottom: 0;
}

/* Credentials */
.yt-credentials {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.yt-credential-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.yt-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.yt-credential-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 4px;
}

.yt-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
  border-radius: var(--sc-radius-md);
}


/* Lives list */
.yt-lives-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.yt-live-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: var(--sc-surface-tint-subtle);
  border-radius: var(--sc-radius-md);
  transition: background var(--sc-duration-fast) var(--sc-easing-standard);

  &:hover {
    background: var(--sc-surface-tint-hover);
  }
}

.yt-live-active {
  border-left: 3px solid var(--v-primary-base);
}

.yt-live-info {
  display: flex;
  align-items: center;
  min-width: 0;
}

.yt-live-title {
  font-size: 0.875rem;
  color: var(--v-text_primary-base);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


/* Switch overrides */
::v-deep .v-input--switch {
  margin: 0;
  padding: 0;
}

::v-deep .v-input--switch { margin: 0; padding: 0; }
</style>
